export const NFSE_ENQUADRAMENTO_FIELDS = [
  { name: 'nome', label: 'Nome', required: true, type: 'text', md: 6 },
  {
    name: 'codigo_tributario_municipio',
    label: 'Código Tributário do Munícipio (CTISS)',
    required: true,
    type: 'text',
    md: 6,
  },
  {
    name: 'natureza_operacao',
    label: 'Natureza da Operação',
    required: true,
    type: 'select',
    md: 6,
    options: [
      { value: 1, label: 'Tributação no município' },
      { value: 2, label: 'Tributação fora do município' },
      { value: 3, label: 'Isenção' },
      { value: 4, label: 'Imune' },
      { value: 5, label: 'Exigibilidade suspensa por decisão judicial' },
      {
        value: 6,
        label: 'Exigibilidade suspensa por procedimento administrativo',
      },
    ],
  },
  {
    name: 'item_lista_servico',
    label: 'Item da Lista de Serviço (LC 116)',
    type: 'text',
    md: 6,
  },
  {
    name: 'aliquota_iss',
    label: 'Alíquota ISS',
    type: 'percentage',
    md: 6,
    defaultValue: 0,
    helperText: 'Somente se o município exigir',
  },
]

export const NFSEN_ENQUADRAMENTO_FIELDS = [
  { name: 'nome', label: 'Nome', required: true, type: 'text', md: 6 },
  {
    name: 'codigo_tributacao_nacional_iss',
    label: 'Código de trib. nacional do ISSQN',
    type: 'text',
    md: 6,
  },
  {
    name: 'codigo_tributacao_municipal_iss',
    label: 'Código de trib. municipal do ISSQN',
    type: 'text',
    md: 6,
  },
  {
    name: 'codigo_interno_contribuinte',
    label: 'Código Interno do Contribuinte',
    type: 'text',
    md: 6,
  },
  {
    name: 'aliquota_iss',
    label: 'Alíquota ISS',
    type: 'percentage',
    md: 6,
    defaultValue: 0,
    helperText: 'Somente se o município exigir',
  },
]
